import r from "react";
import n from "prop-types";
import d from "react-number-format";
import { Input as s, Icon as m, HSpacer as u, Text as g } from "@mqd/volt-base";
const c = " ";
function l(e) {
  const i = () => e.type === "percentage" ? { content: /* @__PURE__ */ r.createElement("div", { style: { margin: "-17px -7px" } }, `${c} % ${c}`) } : o(), o = () => {
    if (!e.rightAddOn)
      return null;
    let t = null;
    switch (e.rightAddOn) {
      case "CAD":
        t = "canada";
        break;
      default:
        t = "united states";
    }
    return {
      content: /* @__PURE__ */ r.createElement("div", { style: { display: "flex", width: 62, height: 24, margin: "0px -6px 0px -10px" } }, /* @__PURE__ */ r.createElement(m, { type: t, noHoverEffects: !0, style: { width: 24 } }), /* @__PURE__ */ r.createElement(u, { factor: 0.6 }), /* @__PURE__ */ r.createElement(g, null, e.rightAddOn))
    };
  }, a = ({ floatValue: t }) => e.isAllowed && typeof e.isAllowed == "function" ? e.isAllowed(t) : e.type === "percentage" ? t < 100 && t > 0 || !t : t < 1e6 || !t;
  return /* @__PURE__ */ r.createElement(
    d,
    {
      ...e,
      customInput: s,
      rightAddOn: i(),
      isAllowed: a
    }
  );
}
l.propTypes = {
  thousandSeparator: n.bool,
  fixedDecimalScale: n.bool,
  allowLeadingZeros: n.bool,
  decimalScale: n.number,
  prefix: n.string,
  format: n.string,
  mask: n.string,
  suffix: n.string,
  allowEmptyFormatting: n.bool,
  allowNegative: n.bool,
  isAllowed: n.any,
  type: n.oneOf(["percentage", "currency"]),
  rightAddOn: n.oneOf(["USD", "CAD"])
};
l.defaultProps = {
  thousandSeparator: !0,
  fixedDecimalScale: !0,
  allowLeadingZeros: !0,
  decimalScale: 2,
  type: "currency",
  kind: "maskedInput"
};
const f = (e, i = {}) => !e && e !== 0 ? null : e.toLocaleString(void 0, {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  ...i
}), w = (e, i = "USD") => {
  if (!e && e !== 0)
    return null;
  const o = e < 0, a = o ? e * -1 : e, t = f(a, { minimumFractionDigits: 2 });
  return (o ? `(${t})` : t) + " " + i;
};
export {
  l as MaskedInput,
  f as formatMoney,
  w as formatMoneyAndNegative
};
